export default "__VITE_ASSET__CeiUUd8K__"